import { getLinkedInLogin, getLinkedInUserInfo, getUser } from "api/calls";
import { LinkedInRedirectType } from "api/const";
import axios from "axios";
import { AuthModel, LinkedInUser } from "components/types";
import { LoginType } from "components/types/Context";
import { MatchDate } from "components/types/types";
import { useContext, useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useAuth } from "shared/auth";
import { AppGeneralContext } from "shared/GeneralContext/GeneralContext";
import { useGuestView } from "shared/GeneralContext/GuestContext";

export const LinkedInPage = () => {

    const navigate = useNavigate();

    const [searchParams, setSearchParams] = useSearchParams();
    const { saveAuth, setCurrentUser } = useAuth()
    const {
        getUserData,
        setLoadingModal,
        setErrorModal,
        setClosedModal,
        setModalDatesIsOpen,
        setMatchCallDates
    } = useContext(AppGeneralContext)

    
    useEffect(() => {
        setLoadingModal()
        return () => setClosedModal()
    }, [])

    const getLinkedInRedirectType = (state: string | null) => {
        if (!state) {
            return null
        }
        const splitState = state.split("_");
        if (splitState.length !== 2) {
            return null
        }
        return splitState[1] as LinkedInRedirectType
    }

    const navigateToRegister = (linkedInUser?: LinkedInUser) => {
        setSearchParams(undefined)

        navigate('/getStarted/corporate', { state: linkedInUser })
    }

  

    useEffect(() => {
        const code = searchParams.get("code");
        const state = searchParams.get("state");
        const redirectType = getLinkedInRedirectType(state);
        if (!code || !redirectType) {
            return
        }

        if (redirectType === LinkedInRedirectType.REGISTER) {
            getLinkedInUserInfo(code).then((resp) => {
                // setClosedModal()

                if (resp.isSuccess) {
                    navigateToRegister(resp.response?.data);
                }
            })
            return
        }
        
        getLinkedInLogin(code).then(async (resp) => {

            if (!resp.isSuccess || !resp.response) {
                return
            }

            if (!resp.response?.jwtToken) {
                navigateToRegister(resp.response?.linkedInUser);
                return
            }

            const auth = { jwtToken: resp.response?.jwtToken, isStartUp: false } as AuthModel;
            saveAuth(auth)

            axios.defaults.headers.common['Authorization'] = "Bearer " + resp.response?.jwtToken;

            const getUserResponse = await getUser();
            if (!getUserResponse.isSuccess || !getUserResponse.response) {
                setCurrentUser(undefined)
                setErrorModal(!!getUserResponse.error ? getUserResponse.error : "Invalid login or password")
                return
            }
            setLoadingModal()
            setCurrentUser({ ...getUserResponse.response, roleType: LoginType.corporate })
            const dataUserLoaded = await getUserData(LoginType.corporate)

            if (!dataUserLoaded) {
                setErrorModal()
                return
            }
            // setClosedModal()

            navigate("/corporate/profile")
        })
    }, [searchParams])


    return (
        <></>
    );
};

